import Paper from '@/components/Paper'
import {
    DataTableCustomized,
    FilterBar,
} from '@/components/ui/data-table-customized'
import { useCustomerServices } from '@/modules/Customer/hooks/use-customer-services'
import { Typogaphy } from 'vnetwork-ui'

/**
 * Official Services Table
 * Active/production services (is_poc: false)
 */
export const OfficialServices = () => {
    const {
        services,
        pagination,
        stateComponent,
        isFetching,
        params,
        control,
        setFilter,
        searchInputProps,
        columns,
        filterItems,
        expandedRowRender,
        rowExpandable,
        handleSortChange,
        handlePageChange,
        handlePageSizeChange,
        t,
    } = useCustomerServices({ isPoc: false })

    return (
        <Paper>
            <div className="mb-2">
                <Typogaphy className="font-medium text-primary uppercase">
                    {t('official-services')}
                </Typogaphy>
            </div>

            <FilterBar
                control={control}
                setFilter={setFilter}
                items={filterItems}
                hideSearch
            />

            {stateComponent || (
                <DataTableCustomized
                    columns={columns}
                    rows={services}
                    rowKey={(row) => String(row?.service_id)}
                    size="small"
                    resizable
                    loading={!services.length && !pagination}
                    isFetching={isFetching}
                    emptyMessage={t('no-services', {
                        defaultValue: 'No services found',
                    })}
                    sorting={{
                        sortBy: params.sort_by,
                        sortOrder: params.sort_order,
                        onSortChange: handleSortChange,
                    }}
                    expandable={{
                        expandedRowRender,
                        rowExpandable,
                    }}
                    pagination={{
                        page: params.page || 1,
                        pageSize: params.page_size || 10,
                        total: pagination?.total || 0,
                        onPageChange: handlePageChange,
                        onPageSizeChange: handlePageSizeChange,
                        pageSizeOptions: [10, 20, 50, 100],
                    }}
                    toolbar={{
                        search: {
                            ...searchInputProps,
                            placeholder: t('search-service', {
                                defaultValue: 'Search services...',
                            }),
                        },
                        settings: {
                            show: true,
                            storageKey: 'customer-official-services',
                        },
                    }}
                />
            )}
        </Paper>
    )
}
